import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import type { RenterProfile } from '@zg-rentals/clickstream';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ CLICKSTREAM });

export const trackRenterProfileEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  { renter_profile: RenterProfile['renter_profile'] | null }
>('CLICKSTREAM');
